import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface Props {
  iconType: 'success' | 'failure'
  text: string
  className?: string
  hideIcon?: boolean
}

const mediaQuery = [{ screen: '(min-width: 280px)', width: '16px' }]
function getIconSrcKey(iconType: 'success' | 'failure'): string {
  switch (iconType) {
    case 'success':
      return 'icons/checkmark-right.png'
    case 'failure':
      return 'icons/invalid-icon-2x.png'
    default:
      return ''
  }
}

export default function IconWithMessage({
  hideIcon = false,
  className = '',
  iconType,
  text,
}: Props): React.ReactElement {
  return (
    <div className={`flex ${className}`}>
      <div className={`flex-none w-4 h-5 ${hideIcon ? 'hidden' : ''}`}>
        <ResponsiveImage
          height={19}
          imageWidths="16"
          mediaQuery={mediaQuery}
          srcKey={getIconSrcKey(iconType)}
          width={16}
        />
      </div>
      <div className={`text-xxs lg:text-xs pl-1 ${iconType === 'failure' ? 'text-red-error' : ''}`}>{text}</div>
    </div>
  )
}
